<template>
  <div style="display:flex;justify-content:space-between;">
    <div
      v-for="(color, key) in $store.state.insight.insight_pts_color"
      :key="key"
      style="min-width:80px;"
      class="separator-vertical-grey"
    >
      <div
        :style="$store.state.insight.insight_pts_color[key]"
        style="cursor:pointer;"
      >
        <b-tooltip type="is-info" :label="$t('admin.showSignificationColors')">
          <p @click="popUpsignificationCouleur(key)" style="font-size:1.5em">
            {{
              props === "all"
                ? TotalParticipantColor[key]
                : insight_TotalParticipantColorCheckboxs[key]
            }}
          </p>
        </b-tooltip>
      </div>
    </div>
    <b-modal :active.sync="isSignificationModalActive" :width="1000">
      <significationCouleur :id="id" />
    </b-modal>
  </div>
</template>
<script>
import significationCouleur from "@/components/popup/SignificationCouleur";
import { mapGetters } from "vuex";

export default {
  props: ["props"],
  components: {
    significationCouleur,
  },
  data() {
    return {
      id: 1,
      isSignificationModalActive: false,
    };
  },
  computed: {
    ...mapGetters([
      "TotalParticipantPts",
      "TotalParticipantColor",
      "insight_TotalParticipantColorCheckboxs",
      "insight_TotalParticipantPtsCheckboxs",
    ]),
  },
  methods: {
    popUpsignificationCouleur(key) {
      // bidouillage suite aux inombrables changements de sens des couleurs
      if (key === 0) this.id = 1;
      if (key === 1) this.id = 0;
      if (key === 3) this.id = 2;
      if (key === 2) this.id = 3;
      this.isSignificationModalActive = true;
    },
  },
};
</script>
